
  import { defineComponent } from 'vue';
  import { Icon } from '@/ui/components/icon/Icon';

  interface AttachedFileProps {
    index: number;
    fileName: string;
    fileSize?: string | null;
  }

  export default defineComponent<AttachedFileProps>({
    components: {
      Icon,
    },
    props: ['index', 'fileName', 'fileSize'],
    emits: ['delete'],
  });
